var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 3.5c.5 2.2 2 3.6 4.2 3.8v2.8c-1.5.1-2.9-.3-4.2-1.1v6.3c0 3.1-2.5 5.2-5.3 5.2-2.8 0-5.3-2.1-5.3-5.2s2.5-5.2 5.3-5.2c.4 0 .8 0 1.1.1v2.9c-.3-.1-.7-.2-1.1-.2-1.4 0-2.5 1.1-2.5 2.4s1.1 2.4 2.5 2.4 2.6-1.1 2.6-2.4V3.5H15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTiktok);
export default __webpack_public_path__ + "static/media/link-tiktok.9421b4b2d893733b033463fd36747faa.svg";
export { ForwardRef as ReactComponent };